import React from "react";
import { Modal } from "react-bootstrap";
import Input from "./common/input";
import Select from "./common/select";

const goals = [
  { id: "Min", name: "Min" },
  { id: "Max", name: "Max" },
];

const DashboardModal = ({
  show,
  data,
  handleChange,
  handleClick,
  handleClose,
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton className="bg-warning">
        <Modal.Title>Edit Parameter</Modal.Title>
      </Modal.Header>
      <form>
        <Modal.Body>
          <div className="form-row">
            <div className="col">
              <Input
                name="TARGET_CODE"
                label="Target Code"
                value={data.TARGET_CODE}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col">
              <Input
                name="HISTORY"
                label="History"
                type="number"
                value={data.HISTORY}
                min={1}
                max={28}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col">
              <Input
                name="LABEL"
                label="Label"
                value={data.LABEL}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col">
              <Select
                name="GOAL"
                label="Goal"
                value={data.GOAL}
                options={goals}
                onChange={handleChange}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={handleClick}>
            Update
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default DashboardModal;
